import React from "react";
import FeedbackCard from "./FeedbackCard";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import InfiniteScroll from "react-infinite-scroller";
import { useDispatch, useSelector } from "react-redux";
import { fetchFeedbacks } from "../../../store/actions/feedbacks";
import { CircularProgress } from "@material-ui/core";
import { fetchProductFeedback } from "../../../store/actions/store";

export default function FeedBacksModal({
  handleClose,
  open,
  feedbacks,
  productID,
  categoryID,
  parentID,
}) {
  const dispatch = useDispatch();

  //Store Feedback
  const page = useSelector((state) => state.feedbacks?.page);
  const totalPages = useSelector((state) => state.feedbacks?.totalPages);

  //Product Feedback
  const productFeedbackPage = useSelector(
    (state) => state?.store.current_product?.feedback_page
  );
  const productFeedbackTotalPages = useSelector(
    (state) => state?.store.current_product?.feedback_total_pages
  );

  const themeColor = useSelector((state) => state.store.store.settings?.dark);
  const language = useSelector((state) => state.store?.language);

  const handleFetchFeedbacks = (page) => {
    if (productID) {
      dispatch(fetchProductFeedback(productID, categoryID, page, parentID));
    } else {
      dispatch(fetchFeedbacks(page));
    }
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth={true}
    >
      <DialogTitle
        disableTypography
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          flexDirection: language === "arabic" ? "row-reverse" : "row",
        }}
      >
        <h4>{language === "arabic" ? "آراء العملاء" : "Customer reviews"}</h4>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <InfiniteScroll
          useWindow={false}
          loadMore={() =>
            handleFetchFeedbacks(productID ? productFeedbackPage + 1 : page + 1)
          }
          hasMore={
            productID
              ? productFeedbackPage !== productFeedbackTotalPages
              : page !== totalPages
          }
          loader={
            <div
              style={{ display: "flex", justifyContent: "center", padding: 15 }}
            >
              <CircularProgress style={{ color: themeColor }} />
            </div>
          }
        >
          {feedbacks.map((feedback) => (
            <FeedbackCard feedback={feedback} fromModal />
          ))}
        </InfiniteScroll>
      </DialogContent>
    </Dialog>
  );
}
